import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule, Routes } from '@angular/router';
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { HttpClientModule } from '@angular/common/http';
import { AppComponent } from './app.component';


import { InputTextModule } from 'primeng/inputtext';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import { NgxCaptchaModule } from 'ngx-captcha';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SharedModule } from './common/shared/shared.module';

import { DialogService } from 'primeng/dynamicdialog';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { MessageService } from 'primeng/api';


// User Services
import { UserService } from './services/users.service';  
import { CompanyService } from './services/companies.service';
import { ProductService } from './services/product.service';
import { AuthService } from './services/auth.service';

// Services
import { ReportsService } from './services/reports.service';
import { BugReportsService } from './services/bug_reports.service';

//Pages
import { LoginComponent } from './pages/login/login.component';
import { ValidateEmailComponent } from './pages/public/validate_email/validate_email.component';
import { NotificationsComponent } from './pages/notifications/notifications.component'
import { CustomComponent } from './pages/custom/custom.component';
import { ImadataService } from './services/imadata.service';
import { STICKY_MESSAGE_SERVICE_PROVIDER } from 'src/app/services/sticky-message.service';



// import { HeaderComponent } from './components/header/header.component';
// import { SidebarComponent } from './components/sidebar/sidebar.component'; 
const routes: Routes = [
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: 'login', component:LoginComponent},
  { path: 'auth/complete-registration', component: ValidateEmailComponent},
  { path: 'notifications', component:NotificationsComponent},
  { path: 'custom', component:CustomComponent},
  { path: 'demo', loadChildren: () => import('./pages/clients/demo/demo.module').then(m => m.DEMOModule) },
  { path: 'imadata', loadChildren: () => import('./pages/clients/imadata/imadata.module').then(m => m.IMADATAModule) },
  { path: 'gya', loadChildren: () => import('./pages/clients/gya/gya.module').then(m => m.GYAModule) },
  { path: 'pan-y-miel', loadChildren: () => import('./pages/clients/pan-y-miel/pan-y-miel.module').then(m => m.PanYMielModule) },
  { path: 'terraza', loadChildren: () => import('./pages/clients/terraza/terraza.module').then(m => m.TerrazaModule) },
  { path: 'casa-del-agua', loadChildren: () => import('./pages/clients/casa-del-agua/casa-del-agua.module').then(m => m.CasaDelAguaModule) },

  // { path: 'login', loadChildren: './login/login.module#LoginModule' },
  // { path: 'signup', loadChildren: './signup/signup.module#SignupModule' },
  // { path: 'not-found', loadChildren: './not-found/not-found.module#NotFoundModule' },
  // { path: '**', redirectTo: '' }
];

@NgModule({
  providers: [
    UserService,
    CompanyService,
    ProductService,
    AuthService,
    ImadataService,
    ReportsService,
    DialogService,
    DynamicDialogRef,
    STICKY_MESSAGE_SERVICE_PROVIDER, 
    BugReportsService,
  ],
  declarations: [
    AppComponent,
    //Components
    // HeaderComponent,
    // SidebarComponent,
    //Pages
    LoginComponent,
    ValidateEmailComponent,
    NotificationsComponent,
    CustomComponent,
  ],
  imports: [
     // Importa el módulo que contiene AdministrationComponent
    BrowserModule,
    SharedModule,
    NgxCaptchaModule,
    HttpClientModule,
    RouterModule.forRoot(routes),
    BrowserAnimationsModule,
    FontAwesomeModule,
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
